import { useCallback } from 'react';
import { presign, uploadToS3, confirm, validateImageFile, type MediaCategory } from '@/lib/upload';

/** 홈 팝업 본문 이미지 presign 카테고리. */
const HOME_POPUP_IMAGE_CATEGORY: MediaCategory = 'CMS_POPUP';

/**
 * RichTextEditor 의 `onUploadImage` 에 그대로 넘기는 업로드 함수.
 * presign → S3 직접 PUT → confirm 3단계로 publicUrl 을 돌려준다(공지 업로드와 동일 흐름).
 */
export const useHomePopupImageUpload = (): ((file: File) => Promise<string>) =>
  useCallback(async (file: File): Promise<string> => {
    const validationError = validateImageFile(file);
    if (validationError) {
      throw new Error(validationError);
    }

    const [slot] = await presign([{ file, category: HOME_POPUP_IMAGE_CATEGORY }]);
    if (!slot) {
      throw new Error('업로드 URL 발급 응답이 올바르지 않습니다.');
    }

    await uploadToS3([{ item: slot, file }]);

    const confirmed = await confirm([slot.fileId]);
    const publicUrl = confirmed.get(slot.fileId) ?? slot.publicUrl;
    if (!publicUrl) {
      throw new Error('업로드한 이미지 주소를 확인하지 못했습니다.');
    }
    return publicUrl;
  }, []);
